import React, { useEffect, useState } from 'react';

import { useGetFace } from '@vlabs/api/artemy/client';
import { useHasPermission, usePageAccess } from '@vlabs/permissions';
import { ButtonSwitch, ButtonSwitchGroup } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { GoToCardButton } from '../../features/go-to-card';
// ponytail: AttachFaceToCard в point3 не используется, функционал сырой (GUI-3979)
// import { AttachFaceToCardButton } from '../attach-face-to-card-button';
import {
  useVmsFromSourceName,
  VideoArchiveWidget,
} from '../video-archive';
import { EventTopMatchInfo } from './components/EventTopMatchInfo.point3';
import st from './EventTopMatchPanel.module.sass';

const TABS = {
  video: 'video',
  info: 'info',
};

function EventTopMatchPanel({ event }) {
  const { t } = useTranslation();
  const canReadStream = useHasPermission('stream', 'read');
  const canViewStreamsFs = usePageAccess('streams_fs');
  const canViewVideoArchive = canReadStream && canViewStreamsFs;
  const canReadCard = useHasPermission('card', 'read');
  const canViewCardDetails = usePageAccess('cards_details');
  // ponytail: AttachFaceToCard в point3 не используется (GUI-3979)
  // const canCreateCard = useHasPermission('card', 'create');
  const topMatch = event?.top_match;
  const matchType = topMatch?.face_id ? 'face' : 'event';
  const getFace = useGetFace(topMatch?.face_id ?? '', undefined, {
    query: {
      enabled: matchType === 'face' && !!topMatch?.face_id,
    },
  });
  // В новом point3 идентификатор карточки приходит в card_id (ранее external_id)
  const cardId = getFace.data?.card_id;

  const { vmsSource } = useVmsFromSourceName(event?.source);
  const [activeTab, setActiveTab] = useState(TABS.video);
  const hasVideo = canViewVideoArchive && !!vmsSource;
  const hasMatch = !!topMatch;
  const showSwitch = hasVideo && hasMatch;
  let infoCardId;
  if (canReadCard) {
    infoCardId = cardId;
  }

  useEffect(() => {
    if (vmsSource && canViewVideoArchive) {
      setActiveTab(TABS.video);
    } else if (topMatch) {
      setActiveTab(TABS.info);
    }
  }, [topMatch, vmsSource, canViewVideoArchive]);

  if (!topMatch && !vmsSource) {
    return (
      <div className={st.NoMatchDummy}>
        {t('lunapoint:панель оператора.no data')}
      </div>
    );
  }

  return (
    <div className={st.Root}>
      <div className={st.ButtonsSection}>
        {showSwitch ? (
          <ButtonSwitchGroup
            className={st.SwitchGroup}
            data-testid="topMatchSwitch"
            onChange={setActiveTab}
            size="small"
            value={activeTab}
            variant="square"
          >
            <ButtonSwitch value={TABS.video}>
              {t('lunapoint:map stream.toggle buttons.video')}
            </ButtonSwitch>
            <ButtonSwitch value={TABS.info}>
              {t('lunapoint:карточка персоны.совпадение')}
            </ButtonSwitch>
          </ButtonSwitchGroup>
        ) : (
          <div
            className={st.Heading}
            data-testid="topMatchHeading"
          >
            {hasVideo
              ? t('lunapoint:map stream.toggle buttons.video')
              : t('lunapoint:карточка персоны.совпадение')}
          </div>
        )}

        {!!canReadCard && !!canViewCardDetails && !!cardId && <GoToCardButton cardId={cardId} />}

        {/*
        ponytail: AttachFaceToCard в point3 не используется — функционал сырой (GUI-3979)
        {canReadCard
          && canCreateCard
          && activeTab === TABS.info
          && matchType === 'face'
          && !!getFace.data?.face_id
          && !getCard.data && (
          <AttachFaceToCardButton
            data-testid="FaceId.addToFaceCard"
            faceId={getFace.data.face_id}
            onAttachFaceToCard={() => getCard.refetch()}
            size="small"
          />
        )}
      */}
      </div>

      <div className={st.MainSection}>
        {activeTab === TABS.info && !!topMatch && (
          <EventTopMatchInfo
            cardId={infoCardId}
            key={topMatch.face_id ?? topMatch.event_id}
            topMatch={topMatch}
          />
        )}

        {!!canViewVideoArchive && activeTab === TABS.video && !!vmsSource && (
          <div className={st.VideoArchive}>
            <VideoArchiveWidget
              startTime={event?.create_time}
              vmsSource={vmsSource}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export { EventTopMatchPanel };
